import { apiClient } from "./client-axios";

export const swrFechter = (url: string) => apiClient(url).then((res) => res.data.data);
